import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(`icon ${_ctx.asc ? 'asc' : 'desc'}`),
    viewBox: "0 0 20 20",
    height: "13",
    width: "13",
    xmlns: "http://www.w3.org/2000/svg"
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 0h20v20H0V0z",
      fill: "none"
    }, null, -1),
    _createElementVNode("path", { d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" }, null, -1)
  ]), 2))
}